<div
  class="message-board-notif"
  [class.has-messages]="messageBoardService.Retry_order_count > 0 || (items && items.length > 0)"
  (click)="messageBoardService.show()"
>
  <ng-container *ngIf="messageBoardService.Retry_order_count > 0">
    <ion-spinner name="crescent" color="primary"></ion-spinner>
    <ion-label>One moment, retrying the failed print dockets</ion-label>
  </ng-container>

  <ng-container *ngIf="messageBoardService.Retry_order_count === 0">
    <ion-icon name="alert-circle" color="warning"></ion-icon>
    <ion-label>See all print errors</ion-label>
  </ng-container>
</div>

<ion-backdrop tappable="true"></ion-backdrop>
<ion-button class="close-btn" fill="clear" (click)="messageBoardService.hide()">
  <ion-icon slot="icon-only" name="close-outline"></ion-icon>
</ion-button>

<ion-content>
  <ion-item class="message-board-header" lines="full">
    <ion-label class="header-label"> The following Dockets didn't print </ion-label>

    <ion-button class="hub-btn print-retry-btn" slot="end" (click)="messageBoardService.retryAllFailedPrintingError()">
      <ion-icon name="print-outline" slot="start"></ion-icon>
      Retry All
    </ion-button>
  </ion-item>

  <ion-virtual-scroll
    #messageBoardVirtualScroll
    [items]="items"
    approxItemHeight="100px"
    [trackBy]="itemTrackByFn"
    [itemHeight]="itemHeightFn"
  >
    <ion-item *virtualItem="let item" class="message-board-item ion-activatable ripple-parent">
      <div class="message-board-item-content">
        <div *ngIf="item.Details" class="docket-title">
          <span
            class="context-icon icon icon-{{ item.Details.context_type }} {{ item.Details.context_type }}-bg-color"
          ></span>
        </div>

        <ion-label>
          <p class="board-text" [innerHTML]="item.Message"></p>
          <p class="board-subtext">#{{ item.Details.order }} | {{ item.Time }}</p>
        </ion-label>

        <div class="board-cta-container">
          <ion-button class="hub-btn print-retry-btn" (click)="messageBoardService.viewItem(item, 'retry')"
            >Retry</ion-button
          >
          <ion-button class="print-dismiss-btn" fill="clear" (click)="messageBoardService.removeItem(item.ID)">
            <ion-icon slot="icon-only" name="close-outline"></ion-icon>
          </ion-button>
        </div>
      </div>

      <!-- <ng-container *ngIf="item.Buttons">
        <ion-button *ngFor="let btn of item.Buttons" class="{{btn.cssClass || ''}}" (click)="messageBoardService.viewItem(item, btn.role); messageBoardService.hide()">
          {{btn.label}}
        </ion-button>
      </ng-container> -->
      <ion-ripple-effect></ion-ripple-effect>
    </ion-item>
  </ion-virtual-scroll>
</ion-content>
